import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "v-error" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "main__action" }

import {RefreshCcw04} from "utruckin-icons";
import CommonButton from "@/components/common/CommonButton.vue";
import {useRouter} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'UnauthorizedView',
  setup(__props) {

const router = useRouter();

const goBack = () => {
  router.go(-1);
}

const goHome = () => {
  router.push("/");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "main__content" }, " 401 ", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "main__headline" }, " You’re not authorized ", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "main__description" }, " You’re logged in, but you don’t have access to this resource. If you believe this is a mistake, contact support or your administrator. ", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(CommonButton, {
          onClick: goBack,
          type: "outline",
          prepend: "",
          "prepend-icon": _unref(RefreshCcw04),
          label: "Refresh"
        }, null, 8, ["prepend-icon"]),
        _createVNode(CommonButton, {
          onClick: goHome,
          type: "primary",
          label: "Go to home"
        })
      ])
    ])
  ]))
}
}

})